module.exports = __webpack_public_path__ + "img/minenv.420acbf5.png";